<template>
	<div class="details-view-child mx-auto p-0 sm:p-4">
		<div class="mx-auto">
			<div ref="detailsContent" id="detailsContent" class="text-gray-700">
				<div class="btn-grup flex justify-between items-start border-b no-print pb-2">
					<div class="flex w-full md:flex-nowrap flex-wrap">
						<!-- <div class="flex items-center" v-if="collectionModeData?.hideHeaderLanguageSwitch">
							<LanguageSwitcher class="mr-3 no-print"  :languages="languageList" :hideLabel="false" />

							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white no-print"
								:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
								type="button"
								v-if="!collectionModeData?.hidePostQuizButton"
								@click="modalVisiblePostQuiz = true"
							>
								<i class="tabler:list-details w-5 h-5 mr-1"></i>
								<span class="hidden md:inline">{{ labels.postquiz }}</span>
							</button>
							<EditButton
								v-if="collectionModeData?.editmode && post?._links.postQuiz?.href"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
								:id="post?.identifier ?? ''"
								:type="collectionModeData?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"
								:overrideURL="post?._links.postQuiz?.href"
						/>
						</div>						 -->
						<div class="audio-player details-audio-player relative no-print ml-auto">
							<EditButton
								v-if="collectionModeData?.editmode && !isLanguageReviewMode && post?.file_url"
								class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-1 px-1 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all text-secondary !hover:text-white no-print z-2"
								:id="post?.identifier ?? ''"
								type="podcast"
								:overrideURL="post?._links?.podcastSlideshowConversations?.href"
							/>
							<SmallSoundPlayer v-if="post && post?.file_url" :jsonData="post" :language="selectedLanguage" :autoSuspend="false"
							/>
						</div>

					</div>

				</div>
				<DialogModal
					v-if="isModalPostQuiz"
					v-model:visible="modalVisiblePostQuiz"
					modal
					:header="labels.postquiz"
					:style="{ width: '40rem' }"
					:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
				>
					<EditButton
						v-if="collectionModeData?.editmode"
						class="absolute right-53px top-[20px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="post?.identifier ?? ''"
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"
						:overrideURL="post?._links.postQuiz.href"
					/>
					<PostQuiz :jsonData="post" :modalVisiblePostQuiz="modalVisiblePostQuiz" :collectionMode='collectionModeData' @close="modalVisiblePostQuiz = false" />
				</DialogModal>
				<SliderPanel
					v-else
					v-model:visible="modalVisiblePostQuiz"
					:title="labels.postquiz"
					headerStyle="dark"
					size="xl"
					icon="tabler:list-check"
					:dismissable="false"
				>
					<div class="h-full overflow-y-auto p-4">
						<div v-if="collectionModeData?.editmode" class="mb-3 flex justify-end">
							<EditButton
								class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier ?? ''"
								:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"
								:overrideURL="post?._links.postQuiz.href"
							/>
						</div>
						<PostQuiz
							:jsonData="post"
							:modalVisiblePostQuiz="modalVisiblePostQuiz"
							:collectionMode="collectionModeData"
							@close="modalVisiblePostQuiz = false"
						/>
					</div>
				</SliderPanel>

				<DialogModal group="templating">
					<template #message="slotProps">
						<div class="flex flex-col items-center w-full gap-3 border-b-1 pb-3">
							<div
								class="border-rounded-50% border-primary w-50px h-50px border-3px flex items-center justify-center"
							>
								<i :class="slotProps.message.icon" class="text-3xl inline-block text-primary-500"></i>
							</div>
							<p class="text-sm text-gray-700">{{ slotProps.message.message }}</p>
						</div>
					</template>
				</DialogModal>

				<div class="">
					<EwLoadingOverlay v-if="loading" class="relative inset-0 z-50 flex items-center justify-center" />  
					
					<section id="section1" class="mb-8">
						<div class="hidden sm:flex justify-end py-3 no-print">
							<PrintButton />
						</div>
						<div class="details-layout-row flex flex-col sm:flex-row justify-center px-3 sm:px-4 w-full" v-if="post">
							<div id="twoCol" v-if="post?.mainOutcome?.sectionLayout != 'oneCol'" class="details-two-col flex flex-col sm:flex-row justify-center w-full">
								<div
									class="details-image-col hidden sm:block w-full pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg"
								>
									<div class="flex items-center gap-2 justify-end mb-3">
										<EditButton
											class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
											type="newImage"
											v-if="collectionModeData?.editmode"
											:id="post?.identifier ?? ''"
											:overrideURL="post?._links.illustration.href"
										/>
										<EditButton
											class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											v-if="collectionModeData?.editmode"
											:id="post?.identifier ?? ''"
											type="imagelist"
											:overrideURL="post?._links.illustration.href"
										/>
									</div>

									<div v-if="post?.illustration && post.illustration.length != 0 && post.mainOutcome.sectionLayout != 'oneCol'" class="details-main-gallery relative">
										<ImageGallery :jsonData="post" :collectionModeData="collectionModeData"></ImageGallery>
									</div>
									<div v-else class="details-main-image-wrap">
										<InteractiveImage class="details-main-image" alt="Image" preview>
											<template #indicatoricon>
												<i class="tabler:eye w-8 h-8 text-white"></i>
											</template>
											<template #image>
													<img
														v-if="!isImageError"
														:src="post?.mainOutcome.imageSrc"
														alt="image"
														@load="isImageLoaded = true"
														@error="isImageError = true"
														class="transition-opacity duration-300 !max-h-[720px]"
														:class="{ 'opacity-0': !isImageLoaded }"
													/>

													<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>
											</template>
											<template #preview="slotProps">
												<div class="p-5">
													<img
														:src="post?.mainOutcome.imageSrc"
														alt="preview"
														class="mx-auto"
														:style="slotProps.style"
														@click="slotProps.onClick"
													/>
													<p class="text-sm italic text-white mt-8 text-left">
														{{ post?.mainOutcome.imageTitle }}
													</p>
												</div>
											</template>
										</InteractiveImage>
										<div class="text-left italic text-sm">
											{{ post?.mainOutcome.imageTitle }}
										</div>
									</div>
								</div>
								<div class="details-text-col w-full md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
									<InplaceEdit
										:inputProps="[{ content: post?.mainOutcome?.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
										:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData"
										:enableCollapseSection="true" :extraContent="post?.mainOutcomeBl.selectHeader">
										<h6
											class="details-select-header my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
											{{ post?.mainOutcome.selectHeader }}
										</h6>
									</InplaceEdit>
									<div class="flex items-center">

												<InplaceEdit
													:inputProps="[
														{
															content: post?.mainOutcome.title,
															propName: 'title',
															inputType: 'textarea',
														},
													]"
													:href="post?._links.mainOutcomeEdit.href"
													:showAssistant="true"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl.title"
													:collectionMode="collectionModeData"
													blockTitle="Edit title"
													:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
												>
													<h4
														class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
													>
														{{ post?.mainOutcome.title }}
													</h4>
												</InplaceEdit>
									</div>
									<div class="gap-3 flex items-center">
										<InplaceEdit
											v-if="!isLanguageReviewMode"
											:collectionMode="collectionModeData"
											:inputProps="[
												{
													content: post?.mainOutcome.publishingDate,
													propName: 'other.publishingDate',
													inputType: 'datepicker',
												},
											]"
											:href="post?._links.mainOutcomeEdit.href"
											blockTitle="Edit publishing date"
										>
											<div class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>
										</InplaceEdit>
										<div v-else class="text-sm inline-flex items-center pt-1 my-1">
											{{ publishingDateFormated }}
										</div>

										<InplaceEdit
											:collectionMode="collectionModeData"
											v-if="!isLanguageReviewMode"
											:inputProps="[
												{
													content: post?.mainOutcome.authorIdentifier,
													propName: 'other.authorIdentifier',
													inputType: 'select',
													selectProps: {
														optionValue: 'identifier',
														optionLabel: 'title',
														class: 'w-15rem',
														optionsCvKey: 'author',
													},
												},
											]"
											:href="post?._links?.mainOutcomeEdit?.href || ''"
											blockTitle="Edit author"
										>
											<div class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
										</InplaceEdit>
										<div v-else class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
									</div>
									<div v-if="post?.mainOutcome?.imageSrc" class="details-mobile-main-image sm:hidden mt-3 mb-2">
										<img
											:src="post.mainOutcome.imageSrc"
											alt="main image"
											class="w-full h-auto rounded"
										/>
										<div v-if="post?.mainOutcome?.imageTitle" class="mt-1 text-left italic text-sm">
											{{ post.mainOutcome.imageTitle }}
										</div>
									</div>
									<div v-if="printMainImage" class="print-main-image-before-lead">
										<img :src="printMainImage.src" alt="main image" />
										<div
											v-if="printMainImage.title || printMainImage.description || printMainImage.copyright"
											class="print-main-image-caption"
										>
											<div v-if="printMainImage.title">
												<strong>{{ labels.titleLabel }}</strong> {{ printMainImage.title }}
											</div>
											<div v-if="printMainImage.description">
												<strong>{{ labels.descriptionLabel }}</strong> {{ printMainImage.description }}
											</div>
											<div v-if="printMainImage.copyright">
												<strong>{{ labels.copyrightLabel }}</strong> {{ printMainImage.copyright }}
											</div>
										</div>
									</div>
									<div v-if="post?.mainOutcome.leadText" class="relative py-3">
										<strong class="mb-4">{{ labels.leadText }}</strong>
										<div id="editLeadText" class="flex items-end relative">
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="post?.mainOutcomeBl.leadText"
												:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
												:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
												<div v-html="post?.mainOutcome.leadText"></div>
											</InplaceEdit>
										</div>
									</div>
									<div id="editKeyMessages" class="relative py-4" v-if="post?.mainOutcome.keyMessages">
										<h3 class="font-bold text-md mb-4">{{ labels.keymessages }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && post.identifier"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div id="editKeyMessagges" class="py-5 px-2">
														<InplaceEdit
															:collectionMode="collectionModeData"
															:enableCollapseSection="true"
															:extraContent="post?.mainOutcomeBl.keyMessages"
															:inputProps="[{ content: post?.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
															:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit key Messages" :showAssistant="true">
															<div v-html="post?.mainOutcome.keyMessages"></div>
														</InplaceEdit>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="main-text relative">
										<div
											v-for="(section, index) in post?.mainOutcome.main_text"
											:key="index"
											:class="{ 'print-section-page-break': hasPrintableSectionContent(section) }"
										>
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="[
													post?.mainOutcomeBl?.main_text?.[index]?.heading ?? '',
													post?.mainOutcomeBl?.main_text?.[index]?.content ?? ''
												]"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block text-gray-700">
															{{ section.heading }}
														</strong>
														<div v-html="section.content" class="text-gray-600"></div>
													</div>
												</div>
											</InplaceEdit>
											<!-- <div class="flex w-full flex-col">
												<template v-if="section.illustrations && section.illustrations.length > 0">
													<div class="flex align-items-center gap-4 my-4">
														<InteractiveImage class="w-[270px] overflow-hidden" alt="Image" preview>
															<template #indicatoricon>
																<i class="tabler:eye w-8 h-8 text-white"></i>
															</template>

															<template #image>
															
																<img
																	v-if="section.illustrations[0].imageSrc && section.illustrations[0].imageSrc !== '' && !hasSectionImageError(index)"
																	:src="section.illustrations[0].imageSrc"
																	alt="image"
																	@load="onSectionImageLoad(index)"
																	@error="onSectionImageError(index)"
																	class="transition-opacity duration-300 w-full h-auto max-w-[270px] object-contain"
																	:class="{ 'opacity-0': !isSectionImageLoaded(index) }"
																/>
																
																<div v-else class="text-gray-400 italic text-sm">No image available</div>
															</template>

															<template #preview="slotProps">
																<div class="p-5">
																	<img
																		v-if="section.illustrations[0].imageSrc && section.illustrations[0].imageSrc !== ''"
																		:src="section.illustrations[0].imageSrc"
																		alt="preview"
																		class="mx-auto"
																		:style="slotProps.style"
																		@click="slotProps.onClick"
																	/>
																	<p class="text-sm italic text-white mt-8 text-left">
																		{{ section.illustrations[0]?.imageTitle || '' }}
																	</p>
																</div>
															</template>
														</InteractiveImage>
														<div class="rounded bg-primary-50/20 p-3 flex flex-col gap-2 flex-1">
															<div class="text-left text-sm">
																<strong>{{labels.titleLabel}}</strong> {{ section.illustrations[0]?.imageTitle || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.descriptionLabel}}</strong> {{ section.illustrations[0]?.imageDescription || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.copyrightLabel}}</strong> {{ section.illustrations[0]?.imageCopyright || '' }}
															</div>
														</div>
													</div>
												</template>
											</div> -->
										</div>
									</div>
									<div class="relative mt-3 py-4" v-if="post?.mainOutcome.references && post.mainOutcome.references.length > 0" >
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && collectionModeData?.id != 'language_review'"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div
														class="py-5 px-2 mx-4"
													>
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome
																	.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PUT"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																	
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>

																		<span
																			v-if="
																				referenceItem.nameDOI || referenceItem.linkDOI
																			"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="
																					referenceItem.nameDOI
																						? `https://doi.org/${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				"
																				target="_blank"
																				class="text-primary"
																			>
																				{{
																					referenceItem.nameDOI
																						? `${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				}}
																			</a>
																		</span>
																		<span
																			v-if="
																				(referenceItem.nameDOI ||
																					referenceItem.linkDOI) &&
																				referenceItem.title
																			"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer no-print">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																	<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a> -->
																	<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

																</div>
															</li>
														</ol>
													</div>
													<!-- <div v-else class="p-5 bg-gray-100 flex items-center">
														<div class="text-center text-danger text-xs inline-flex mx-auto">
															<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
														</div>
													</div> -->
												</div>
											</div>
										</div>
									</div>
									<!-- <div class="relative no-print">
										<RatingItems :jsonData="post" :feedback-url="computedFeedbackUrl" :selectedLanguage="currentLng" @open-postquiz="modalVisiblePostQuiz = true" :collectionMode="collectionModeData" />
									</div> -->

								</div>
							</div>		
							<div id="oneCol" v-else class="details-one-col w-full">
								<div class="flex flex-col sm:flex-row justify-center w-full">
									<div
										class="details-image-col hidden sm:block w-full pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg"
									>
										<div class="flex items-center gap-2 justify-end mb-3">
											<EditButton
												class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
												type="newImage"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												:overrideURL="post?._links.illustration.href"
											/>
											<EditButton
												class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												type="imagelist"
												:overrideURL="post?._links.illustration.href"
											/>
										</div>

										<div class="details-main-image-wrap">
											<InteractiveImage class="details-main-image" alt="Image" preview>
												<template #indicatoricon>
													<i class="tabler:eye w-8 h-8 text-white"></i>
												</template>
												<template #image>
														<img
															v-if="!isImageError"
															:src="post?.mainOutcome.imageSrc"
															alt="image"
															@load="isImageLoaded = true"
															@error="isImageError = true"
															class="transition-opacity duration-300 !max-h-[720px]"
															:class="{ 'opacity-0': !isImageLoaded }"
														/>

														<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>
												</template>
												<template #preview="slotProps">
													<div class="p-5">
														<img
															:src="post?.mainOutcome.imageSrc"
															alt="preview"
															class="mx-auto"
															:style="slotProps.style"
															@click="slotProps.onClick"
														/>
														<p class="text-sm italic text-white mt-8 text-left">
															{{ post?.mainOutcome.imageTitle }}
														</p>
													</div>
												</template>
											</InteractiveImage>
											<div class="text-left italic text-sm">
												{{ post?.mainOutcome.imageTitle }}
											</div>
										</div>
									</div>
									<div class="details-text-col w-full md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
										<InplaceEdit
											:inputProps="[{ content: post?.mainOutcome?.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
											:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData"
											:enableCollapseSection="true" :extraContent="post?.mainOutcomeBl.selectHeader">
											<h6
												class="details-select-header my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
												{{ post?.mainOutcome.selectHeader }}
											</h6>
										</InplaceEdit>
										<div class="flex items-center">

													<InplaceEdit
														:inputProps="[
															{
																content: post?.mainOutcome.title,
																propName: 'title',
																inputType: 'textarea',
															},
														]"
														:href="post?._links.mainOutcomeEdit.href"
														:showAssistant="true"
														:enableCollapseSection="true"
														:extraContent="post?.mainOutcomeBl.title"
														:collectionMode="collectionModeData"
														blockTitle="Edit title"
														:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
													>
														<h4
															class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
														>
															{{ post?.mainOutcome.title }}
														</h4>
													</InplaceEdit>
										</div>
										<div class="gap-3 flex items-center">
											<InplaceEdit
												v-if="!isLanguageReviewMode"
												:collectionMode="collectionModeData"
												:inputProps="[
													{
														content: post?.mainOutcome.publishingDate,
														propName: 'other.publishingDate',
														inputType: 'datepicker',
													},
												]"
												:href="post?._links.mainOutcomeEdit.href"
												blockTitle="Edit publishing date"
											>
												<div class="text-sm inline-flex items-center pt-1 my-1">
													{{ publishingDateFormated }}
												</div>
											</InplaceEdit>
											<div v-else class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>

											<InplaceEdit
												:collectionMode="collectionModeData"
												v-if="!isLanguageReviewMode"
												:inputProps="[
													{
														content: post?.mainOutcome.authorIdentifier,
														propName: 'other.authorIdentifier',
														inputType: 'select',
														selectProps: {
															optionValue: 'identifier',
															optionLabel: 'title',
															class: 'w-15rem',
															optionsCvKey: 'author',
														},
													},
												]"
												:href="post?._links?.mainOutcomeEdit?.href || ''"
												blockTitle="Edit author"
											>
												<div class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
											</InplaceEdit>
											<div v-else class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
										</div>
										<div v-if="post?.mainOutcome?.imageSrc" class="details-mobile-main-image sm:hidden mt-3 mb-2">
											<img
												:src="post.mainOutcome.imageSrc"
												alt="main image"
												class="w-full h-auto rounded"
											/>
											<div v-if="post?.mainOutcome?.imageTitle" class="mt-1 text-left italic text-sm">
												{{ post.mainOutcome.imageTitle }}
											</div>
										</div>
										<div v-if="printMainImage" class="print-main-image-before-lead">
											<img :src="printMainImage.src" alt="main image" />
											<div
												v-if="printMainImage.title || printMainImage.description || printMainImage.copyright"
												class="print-main-image-caption"
											>
												<div v-if="printMainImage.title">
													<strong>{{ labels.titleLabel }}</strong> {{ printMainImage.title }}
												</div>
												<div v-if="printMainImage.description">
													<strong>{{ labels.descriptionLabel }}</strong> {{ printMainImage.description }}
												</div>
												<div v-if="printMainImage.copyright">
													<strong>{{ labels.copyrightLabel }}</strong> {{ printMainImage.copyright }}
												</div>
											</div>
										</div>
										<div v-if="post?.mainOutcome.leadText" class="relative py-3">
											<strong class="mb-4">{{ labels.leadText }}</strong>
											<div id="editLeadText" class="flex items-end relative">
												<InplaceEdit
													:collectionMode="collectionModeData"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl.leadText"
													:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
													:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
													<div v-html="post?.mainOutcome.leadText"></div>
												</InplaceEdit>
											</div>
										</div>

									</div>	
								</div>							
								<div :class="sectionLayoutClass">
									<div class="main-text relative">
										<div
											v-for="(section, index) in post?.mainOutcome.main_text"
											:key="index"
											:class="{ 'print-section-page-break': hasPrintableSectionContent(section) }"
										>
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="[
													post?.mainOutcomeBl?.main_text?.[index]?.heading ?? '',
													post?.mainOutcomeBl?.main_text?.[index]?.content ?? ''
												]"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block text-gray-700">
															{{ section.heading }}
														</strong>
														<div v-html="section.content" class="text-gray-600"></div>
													</div>
												</div>
											</InplaceEdit>
											<div class="flex w-full flex-col">
												<template v-if="section.illustrations && section.illustrations.length > 0">
													<div
														v-for="(illustration, imageIndex) in section.illustrations"
														:key="`${index}-${imageIndex}-${illustration.imageSrc || illustration.imageSrcEdit || 'image'}`"
														class="details-section-illustration-row flex flex-col sm:flex-row items-start gap-4 my-4"
													>
														<InteractiveImage class="details-section-image w-full sm:w-[270px] overflow-hidden" alt="Image" preview>
															<template #indicatoricon>
																<i class="tabler:eye w-8 h-8 text-white"></i>
															</template>

															<template #image>
															
																<img
																	v-if="(illustration.imageSrc || illustration.imageSrcEdit) && !hasSectionImageError(index, imageIndex)"
																	:src="illustration.imageSrc || illustration.imageSrcEdit"
																	alt="image"
																	@load="onSectionImageLoad(index, imageIndex)"
																	@error="onSectionImageError(index, imageIndex)"
																	class="transition-opacity duration-300 w-full h-auto max-w-[270px] object-contain"
																	:class="{ 'opacity-0': !isSectionImageLoaded(index, imageIndex) }"
																/>
																
																<div v-else class="text-gray-400 italic text-sm">No image available</div>
															</template>

															<template #preview="slotProps">
																<div class="p-5">
																	<img
																		v-if="illustration.imageSrc || illustration.imageSrcEdit"
																		:src="illustration.imageSrc || illustration.imageSrcEdit"
																		alt="preview"
																		class="mx-auto"
																		:style="slotProps.style"
																		@click="slotProps.onClick"
																	/>
																	<p class="text-sm italic text-white mt-8 text-left">
																		{{ illustration?.imageTitle || '' }}
																	</p>
																</div>
															</template>
														</InteractiveImage>
														<div class="rounded bg-primary-50/20 p-3 flex flex-col gap-2 flex-1">
															<div class="text-left text-sm">
																<strong>{{labels.titleLabel}}</strong> {{ illustration?.imageTitle || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.descriptionLabel}}</strong> {{ illustration?.imageDescription || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.copyrightLabel}}</strong> {{ illustration?.imageCopyright || '' }}
															</div>
														</div>
													</div>
												</template>
											</div>
										</div>
									</div>
									<div class="relative mt-3 py-4" v-if="post?.mainOutcome.references && post.mainOutcome.references.length > 0" >
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && collectionModeData?.id != 'language_review'"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div
														class="py-5 px-2 mx-4"
													>
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome
																	.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PUT"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																	
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>

																		<span
																			v-if="
																				referenceItem.nameDOI || referenceItem.linkDOI
																			"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="
																					referenceItem.nameDOI
																						? `https://doi.org/${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				"
																				target="_blank"
																				class="text-primary"
																			>
																				{{
																					referenceItem.nameDOI
																						? `${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				}}
																			</a>
																		</span>
																		<span
																			v-if="
																				(referenceItem.nameDOI ||
																					referenceItem.linkDOI) &&
																				referenceItem.title
																			"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer no-print">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																	<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a> -->
																	<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

																</div>
															</li>
														</ol>
													</div>
													<!-- <div v-else class="p-5 bg-gray-100 flex items-center">
														<div class="text-center text-danger text-xs inline-flex mx-auto">
															<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
														</div>
													</div> -->
												</div>
											</div>
										</div>
									</div>
									<!-- <div class="relative no-print">
										<RatingItems :jsonData="post" :feedback-url="computedFeedbackUrl" :selectedLanguage="currentLng" @open-postquiz="modalVisiblePostQuiz = true" :collectionMode="collectionModeData" />
									</div> -->
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useEventBus } from '@vueuse/core';
import axios from 'axios'
import ImageGallery from '../components/ImageGallery.vue';
import PrintButton from '../components/PrintButton.vue';
import PostQuiz from '../components/PostQuiz.vue';
import EditButton from '../components/EditButton.vue';
import SliderPanel from '@/components/SidebarPanel/SidebarPanel.vue'
import { useAppConfig } from '@/composables/useAppConfig';
import { messages } from '@/assets/language';
import type { configCollectionMode, CVResponse, Post, PostDetailsResponse } from '@/types';
import { DateTime } from 'luxon';
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue';
import { CVDataProvided } from '@/types/cvTypes';
import { useAppStore } from '@/stores/app-store'
import EwLoadingOverlay from '@/components/EwLoadingOverlay.vue';
import SmallSoundPlayer from '@/components/SmallSoundPlayer.vue';
import { isLanguageReviewMode as isLanguageReviewCollectionMode } from '@/utils/collectionMode';
import { decodePostHtmlContent } from '@/utils/htmlContent';

const isImageLoaded = ref(false);
const isImageError = ref(false);
const sectionImageLoaded = ref<Record<string, boolean>>({});
const sectionImageError = ref<Record<string, boolean>>({});
const loading = ref( false );

const sectionImageStateKey = (sectionIndex: number, imageIndex: number): string => `${sectionIndex}-${imageIndex}`;

const isSectionImageLoaded = (sectionIndex: number, imageIndex: number): boolean =>
	Boolean(sectionImageLoaded.value[sectionImageStateKey(sectionIndex, imageIndex)]);

const hasSectionImageError = (sectionIndex: number, imageIndex: number): boolean =>
	Boolean(sectionImageError.value[sectionImageStateKey(sectionIndex, imageIndex)]);

const onSectionImageLoad = (sectionIndex: number, imageIndex: number): void => {
	const key = sectionImageStateKey(sectionIndex, imageIndex);
	sectionImageLoaded.value[key] = true;
	sectionImageError.value[key] = false;
};

const onSectionImageError = (sectionIndex: number, imageIndex: number): void => {
	const key = sectionImageStateKey(sectionIndex, imageIndex);
	sectionImageError.value[key] = true;
};

type MainTextIllustration = {
	imageSrc?: string;
	imageSrcEdit?: string;
	imageTitle?: string;
	imageDescription?: string;
	imageCopyright?: string;
};

type PrintMainImageItem = {
	src: string;
	title: string;
	description: string;
	copyright: string;
};

type PrintImageCandidate = {
	imageSrc?: unknown;
	imageSrcEdit?: unknown;
	imageTitle?: unknown;
	imageDescription?: unknown;
	imageCopyright?: unknown;
};

const toImageText = (value: unknown): string => {
	if (typeof value === 'string') {
		return value.trim();
	}
	if (value == null) {
		return '';
	}
	return String(value).trim();
};

const hasPrintableSectionContent = (section: { content?: unknown }): boolean => {
	const textContent = toImageText(section?.content)
		.replace(/<[^>]*>/g, ' ')
		.replace(/&nbsp;/gi, ' ')
		.replace(/\s+/g, ' ')
		.trim();

	return textContent.length > 0;
};

const toFlatIllustrationList = (value: unknown): MainTextIllustration[] => {
	const output: MainTextIllustration[] = [];

	const collect = (entry: unknown): void => {
		if (Array.isArray(entry)) {
			entry.forEach(collect);
			return;
		}

		if (!entry || typeof entry !== 'object') {
			return;
		}

		const candidate = entry as MainTextIllustration;
		if (typeof candidate.imageSrc === 'string' || typeof candidate.imageSrcEdit === 'string') {
			output.push(candidate);
		}
	};

	collect(value);
	return output;
};

const normalizePostSectionIllustrations = (candidate: Post | null): Post | null => {
	if (!candidate?.mainOutcome?.main_text) {
		return decodePostHtmlContent(candidate);
	}

	const normalizedMainText = candidate.mainOutcome.main_text.map((section) => {
		const normalizedIllustrations = toFlatIllustrationList((section as { illustrations?: unknown }).illustrations);

		return {
			...section,
			illustrations: normalizedIllustrations
		};
	});

	return decodePostHtmlContent({
		...candidate,
		mainOutcome: {
			...candidate.mainOutcome,
			main_text: normalizedMainText
		}
	} as Post);
};



const route = useRoute();
const bus = useEventBus<Record<string, any>>('saved');
const { currentLng, currentCollectionMode, 	currentTestyourself, currentPAGE_REQ_ID } = useAppStore()


const AppConfig = useAppConfig();

watch(currentLng, ()=>{
	fetchDataPost()
	
})
const modalVisiblePostQuiz = ref(false);
const isModalPostQuiz = computed(() => AppConfig.urls.postquiz?.modal === true)


function onPropSaved(event: Record<string, any>) {
	console.log(event);
	fetchDataPost();
}

const unsubscribe = bus.on(onPropSaved);

const CVData = ref<CVResponse>({ data: {} });
provide(CVDataProvided, CVData);

// const selectedLanguage = computed( () => ( route.query.lng ) );
const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});

const { selectedLanguage } = defineProps<{
  selectedLanguage?: string;
}>();


// ✅ Funksion që kontrollon nëse duhet marrë nga mainOutcome apo mainOutcomeBl



const postId = (route.params.id as string) || null;


const post = ref<Post | null>(null);
const detailsContent = ref<HTMLElement | null>(null);
const collectionModeData = ref<configCollectionMode | null>(null);
const isLanguageReviewMode = computed(() => isLanguageReviewCollectionMode(collectionModeData.value?.id));
const printMainImage = computed<PrintMainImageItem | null>(() => {
	const galleryImage = post.value?.illustration?.find((item) => {
		return toImageText(item?.imageSrc) || toImageText(item?.imageSrcEdit);
	});
	const image = (galleryImage ?? post.value?.mainOutcome) as PrintImageCandidate | undefined;
	const src = toImageText(image?.imageSrc) || toImageText(image?.imageSrcEdit);

	if (!src) {
		return null;
	}

	return {
		src,
		title: toImageText(image?.imageTitle),
		description: toImageText(image?.imageDescription),
		copyright: toImageText(image?.imageCopyright)
	};
});
const sectionLayoutClass = computed(() => {
	const layout = post.value?.mainOutcome?.sectionLayout;
	
	if (layout === 'oneCol') {
		return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
	}
	if (layout === 'twoCol') {
		return 'md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1';
	}

	// fallback për raste të tjera nëse ndonjëherë mungon vlera
	return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
});

const publishingDateFormated = computed(() => {
	const publishingDate = post.value?.mainOutcome.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});

const fetchDataPost = async () => {
  try {
    loading.value = true;
	sectionImageLoaded.value = {};
	sectionImageError.value = {};

    const url = AppConfig.urls.getList;
    if (!url) throw new Error('getList URL missing');

    const params: Record<string, any> = {
      package_id: route.query.package_id,
      mode: 'details',
      lng: currentLng.value,
      json: 'y', // nëse backend e kërkon
      'collection-mode': currentCollectionMode.value,
      testYourself: currentTestyourself.value,
      PAGE_REQ_ID: currentPAGE_REQ_ID.value,
      offset: 0,
      limit: 15,
      'latest-days': 14
    };

    const response = await axios.get<PostDetailsResponse>(url, {
      params,
      headers: { Accept: 'application/json' }
    });

    const data = response.data?.data ?? null;

    if (data && postId) {
      const selectedPost = Array.isArray(data)
        ? data.find((p) => p.identifier === postId) ?? null
        : data;
      post.value = normalizePostSectionIllustrations(selectedPost);
    } else {
      post.value = null;
    }

    CVData.value = response.data.CV;
    collectionModeData.value = response.data.config ?? null;

  } catch (error) {
    console.error('Failed to fetch details:', error);
  } finally {
    loading.value = false;
  }
};

const refreshListEvent = useEventBus('refresh-listview')
const stopListening = refreshListEvent.on(() => {
  refresh()
})

const refresh = () => {
  fetchDataPost();
};

const openModal = (index: number) => {
  // Merr PDF linkun bazuar në index
  const pdfLink = post.value?.mainOutcome.references[index]?.pdfLink;

  if (!pdfLink) {
    console.error('PDF Link is not available.');
    return;
  }

  // Ndërto URL-në për iframe
  const viewerUrl = `/example/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfLink)}`;

  // Hap modalin duke përdorur Bootstrap API
  const modal = new bootstrap.Modal(document.getElementById('pdfViewer') as HTMLElement);
  modal.show();

  // Vendos URL-në në iframe
  const iframe = document.getElementById('pdfIframe') as HTMLIFrameElement;
  if (iframe) {
    iframe.src = viewerUrl; // Vendos URL-në e ndërtuar
  }
};

onBeforeUnmount( () => {
	unsubscribe();
	document.removeEventListener('refreshList', refresh);
	stopListening(); 

} )


onMounted(() => {
	  console.log('DETAILS ID:', route.params.id)

	fetchDataPost();
});




</script>
<style scoped>
.print-main-image-before-lead {
	display: none;
}

.details-text-col :deep(table) {
	display: block;
	width: 100%;
	max-width: 100%;
	margin: 0.75rem 0 1rem;
	overflow-x: auto;
	border-collapse: collapse;
	font-size: 0.92em;
}

.details-text-col :deep(th),
.details-text-col :deep(td) {
	border: 1px solid #d6deea;
	padding: 0.45rem 0.55rem;
	vertical-align: top;
}

.details-text-col :deep(th) {
	background: #f6f8fc;
	font-weight: 700;
}

@media print {
	.details-view-child,
	#detailsContent,
	.details-layout-row,
	.details-two-col,
	.details-one-col {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		padding-left: 0 !important;
		padding-right: 0 !important;
		margin-left: 0 !important;
		margin-right: 0 !important;
		overflow: visible !important;
	}

	.details-layout-row,
	.details-two-col,
	.details-one-col,
	.details-one-col > div:first-child {
		display: block !important;
		width: 100% !important;
	}

	.details-image-col {
		display: none !important;
	}

	.details-text-col {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		padding: 0 !important;
		margin: 0 !important;
	}

	.print-main-image-before-lead {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		margin: 8mm 0 5mm !important;
		break-inside: avoid;
		page-break-inside: avoid;
	}

	.print-main-image-before-lead img {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		max-height: 245mm !important;
		height: auto !important;
		object-fit: contain !important;
		margin: 0 auto !important;
	}

	.print-main-image-caption {
		margin-top: 3mm;
		font-size: 9pt;
		line-height: 1.35;
		color: #24364f;
	}

	.print-main-image-caption strong {
		color: #0b2346;
	}

	.details-main-gallery,
	.details-main-image-wrap,
	.details-main-image,
	.details-section-illustration-row,
	.details-section-image {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		padding: 0 !important;
	}

	.details-mobile-main-image {
		display: none !important;
	}

	.details-section-illustration-row {
		margin: 8mm 0 !important;
		break-inside: avoid;
		page-break-inside: avoid;
	}

	.print-section-page-break {
		break-before: page;
		page-break-before: always;
		break-after: auto;
		page-break-after: auto;
		break-inside: avoid;
		page-break-inside: avoid;
	}

	.details-section-illustration-row > div:last-child {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		margin-top: 3mm !important;
		background: transparent !important;
		padding: 0 !important;
	}

	.details-image-col :deep(.p-image),
	.details-image-col :deep(.p-image-preview-container),
	.details-section-image :deep(.p-image),
	.details-section-image :deep(.p-image-preview-container) {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
	}

	.details-image-col :deep(img),
	.details-main-image :deep(img),
	.details-section-image :deep(img) {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		max-height: 245mm !important;
		height: auto !important;
		object-fit: contain !important;
		margin: 0 auto !important;
	}
}

@media (max-width: 639.98px) {
	.details-view-child {
		overflow-x: hidden;
	}

	#detailsContent {
		overflow-x: hidden;
	}

	.btn-grup {
		padding-bottom: 0.7rem !important;
		margin-bottom: 0.35rem;
	}

	.details-layout-row {
		padding-left: 0.75rem !important;
		padding-right: 0.75rem !important;
	}

	.details-two-col,
	.details-one-col {
		width: 100%;
		overflow-x: hidden;
	}

	.details-audio-player {
		margin-left: 0 !important;
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 0.7rem;
		margin-bottom: 0.7rem;
	}

	.details-audio-player :deep(.small-player-shell) {
		margin-top: 0.15rem;
		margin-bottom: 0.15rem;
	}

	.details-select-header {
		margin-top: 0.7rem !important;
		margin-bottom: 0.5rem !important;
		line-height: 1.3 !important;
	}

	.details-image-col {
		width: 100% !important;
		padding-right: 0 !important;
		margin-bottom: 0.75rem;
	}

	.details-main-gallery,
	.details-main-image-wrap {
		width: 100%;
	}

	.details-mobile-main-image {
		width: 100%;
	}

	.details-mobile-main-image img {
		display: block;
		width: 100%;
		max-width: 100%;
		height: auto;
		object-fit: contain;
	}

	.details-main-image {
		display: block;
		width: 100%;
	}

	.details-main-image :deep(.p-image),
	.details-main-image :deep(.p-image-preview-container) {
		display: block;
		width: 100%;
		max-width: 100%;
	}

	.details-main-image :deep(img) {
		display: block;
		width: 100% !important;
		max-width: 100% !important;
		height: auto !important;
		object-fit: contain;
	}

	.details-image-col :deep(img) {
		width: 100%;
		max-width: 100%;
		height: auto;
		object-fit: contain;
	}

	.details-section-illustration-row {
		width: 100%;
	}

	.details-section-image {
		max-width: 100% !important;
	}

	.details-section-image :deep(img) {
		width: 100% !important;
		max-width: 100% !important;
		height: auto !important;
		object-fit: contain;
	}

	.details-text-col {
		width: 100% !important;
		min-width: 0;
	}

	.details-text-col :deep(.p-inplace-display) {
		display: block;
		max-width: 100%;
	}

	.details-text-col :deep(*) {
		overflow-wrap: anywhere;
		word-break: break-word;
	}

	#references .py-5.px-2.mx-4 {
		margin-left: 0 !important;
		margin-right: 0 !important;
		padding-left: 0.5rem !important;
		padding-right: 0.5rem !important;
	}
}
</style>
